import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import cn from "classnames";
import { useTranslation } from "react-i18next";

import { ReactComponent as LogoutIcon } from "../../../../media/icons/logout-main.svg";
import { enableScroll, disableScroll } from "../../../../helpers";
import { useKeyDownEscape } from "../../../../helpers/hooks";
import { logoutOfKeycloak } from "../../../../helpers/keycloakLogout";
import styles from "./detailNavigation.module.css";
import { PAID_REFERRALS_V2 } from "../../../../constants/featureFlags";
import { getPaidLeadsBasePath } from "../../../payPerLead/basePath";

export const DetailNavigation = ({ onCloseHandler, keycloak }) => {
  const { t } = useTranslation();

  const wrapperRef = useRef(null);

  // The backdrop is no longer a keyboard control, so Escape is how a keyboard user dismisses the popup. The hook keeps the
  // first render's callback; that is safe because Header opens this popup only while its own state is "links", so
  // onCloseHandler's toggle always takes the close branch.
  useKeyDownEscape(onCloseHandler);

  useEffect(() => {
    disableScroll();
    return () => {
      enableScroll();
    };
  }, []);

  return (
    <>
      <nav ref={wrapperRef} className={styles.nav}>
        <Link onClick={onCloseHandler} className={styles.link} to="/">
          {t("dashboard_nav_feed")}
        </Link>

        <Link onClick={onCloseHandler} className={styles.link} to="/profile">
          {t("dashboard_nav_profile")}
        </Link>

        <Link onClick={onCloseHandler} className={styles.link} to="/inbox">
          {t("dashboard_nav_inbox")}
        </Link>

        <Link onClick={onCloseHandler} className={styles.link} to="/referrals">
          {t("dashboard_nav_referralrequests")}
        </Link>

        <Link onClick={onCloseHandler} className={styles.link} to="/listings">
          {t("dashboard_nav_businessservices")}
        </Link>

        <Link onClick={onCloseHandler} className={styles.link} to={getPaidLeadsBasePath()}>
          {t(PAID_REFERRALS_V2 ? "dashboard_nav_paid_referrals" : "dashboard_nav_leads")}
        </Link>

        <Link onClick={onCloseHandler} className={styles.link} to="/account">
          {t("dashboard_nav_account")}
        </Link>

        <span className={styles.indent} />

        <button
          type="button"
          className={cn(styles.logout, "button--clear")}
          onClick={() => logoutOfKeycloak(keycloak, { redirectUri: `${window.location.origin}/login` })}
        >
          <LogoutIcon />
          {t("dashboard_nav_logout")}
        </button>
      </nav>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions -- a pointer-only backdrop; Escape is the keyboard way out */}
      <div className={styles.background} onClick={onCloseHandler} />
    </>
  );
};
